import styled from '@emotion/styled';

export const SadaKFormList = styled.div``;
